import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class WorkModel extends BaseModel {

    constructor() {
        super({
            name: "work",
            tableName: 'work',
            label: "Danh sách công việc",
            display_key: 'name',
            default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: {
                name: 'id',
                type: "Uuid",
                label: 'ID',
                primaryKey: true,
                display: false
            },
            work_type: {
                name: 'work_type',
                types: "String",
                class: "center",
                custom: "String",
                label: 'Loại công việc',
                sortable: false,
                filter: {
                    type: 'input',
                    match: 'contains'
                },
                refs: 'type_work {id name}'
            },
            name: { 
                name: 'name',
                type: "String",
                class: "center",
                label: 'Tên công việc',
                sortable: false,
                filter: {
                    type: 'input',
                    match: 'contains'
                },
            },
            farm: {
                name: 'farm',
                type: "String",
                custom: "String",
                class: "center",
                label: 'Trang trại',
                filter: {
                    type: 'input',
                    match: 'contains'
                },
                refs: 'farm_has_works {farm{id name}}'
            },
            reports: {
                name: 'reports',
                label: 'Báo cáo',
                type: "CustomUrl",
                custom: "String",
                class: "center",
                refs: 'reports {id name}',
            },
            created_by: {
                name: 'created_by',
                type: "String",
                custom: "String",
                class: "center",
                label: 'Người tạo CV',
                filter: {
                    type: 'input',
                    match: 'contains'
                },
                refs: 'users {id fullname}'
            },
            work_assign: {
                name: 'work_assign_users',
                type: "String",
                class: "center",
                label: 'Người thực hiện',
                filter: {
                    type: 'input',
                    match: 'contains'
                },
            },
            status: {
                name: 'status',
                type: "String",
                custom: "String",
                class: "center",
                label: 'Trạng thái',
                filter: {
                    type: 'input',
                    match: 'contains'
                },
                refs: 'status {id name}'
            },
            content: {
                name: 'content',
                display: false
            },
            unit_has_works: {
                refs: 'unit_has_works {unit{id name}}',
                display: false
            },
            farm_has_works: {
                refs: 'farm_has_works {farm{id name}}',
                display: false
            },
            work_assign_users: {
                refs: 'work_assign_users {user{id fullname}}',
                display: false
            },
            deadline_time: {
                name: 'deadline_time',
                type: "Datetime",
                class: "center",
                label: 'Ngày hoàn thành',
                sortable: false,
                filter: {
                    type: "DateRange", match: "contrains",
                },
            },
            created_at: {
                name: 'created_at',
                type: "Datetime",
                class: "center",
                label: 'Ngày tạo',
                filter: {
                    type: "DateRange", match: "contrains",
                },
            },
            },
        )
    }

}